import React, { useState } from "react";

const useDataTable = (fetchDataTable: (param: PageQueryParams) => any) => {
  const [dataSrc, setDataSrc] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState<PageQueryParams>({
    page: 1,
    perPage: 10,
    paginationMetadataStyle: "body",
  });
  const [metadata, setMetadata] = useState<PaginationMetadata>({
    "x-next-page": 0,
    "x-page": 0,
    "x-pages-count": 0,
    "x-per-page": 0,
    "x-total-count": 0,
  });
  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

  const onChangeTable = async (page: number, pageSize: number) => {
    setParams({
      ...params,
      page: page,
      perPage: pageSize,
    });
  };

  async function getData(params: PageQueryParams) {
    try {
      setLoading(true);
      const res = await fetchDataTable(params);
      const { data, metadata } = res.data as PaginationData<any>;
      setDataSrc(data);
      setMetadata(metadata);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function getDataNoPagination(params: PageQueryParams) {
    try {
      setLoading(true);
      const res = await fetchDataTable(params);
      const { data } = res.data;
      setDataSrc(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchData(params: PageQueryParams) {
    await getData(params);
  }

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedRowKeys(selectedRows.map(item => item.settlement_last_transaction_date));
    },
  };

  function fetchDataNoPagination(params: PageQueryParams) {
    getDataNoPagination(params);
  }
  return {
    dataSrc,
    loading,
    params,
    metadata,
    setDataSrc,
    setLoading,
    setParams,
    setMetadata,
    fetchData,
    fetchDataNoPagination,
    rowSelection,
    selectedRowKeys,
    onChangeTable,
  };
};

export default useDataTable;
